export const blockIconsTravelLocalCafeNew = (
	<span className='material-symbols-outlined'>local_cafe</span>
);
